/*
  Scroll-reveal for the Celtic collection sections (styles in lwb-celtic-reveal.css).

  Each group lists a section root and, in reading order, the parts of it that
  animate in. Parts are tagged with [data-lwb-reveal] and revealed once they
  scroll into view; parts that enter together are staggered by DOM order.
  The hero is not listed: it animates with CSS on first paint.
*/
(function () {
  if (window.lwbCelticReveal) return;
  window.lwbCelticReveal = true;

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var STAGGER_MS = 90;
  var MAX_STAGGER_STEPS = 7;

  // [selector, animation] - animation is '' (slide up), 'fade', 'zoom' or 'left'.
  var GROUPS = [
    { root: '.lwb-celtic-symbols', items: [['.lwb-celtic-symbols__eyebrow'], ['.lwb-celtic-symbols__title'], ['.lwb-celtic-symbols__prompt', 'fade'], ['.lwb-celtic-symbols__card']] },
    { root: '.lwb-celtic-quiz', items: [['.lwb-celtic-quiz__eyebrow'], ['.lwb-celtic-quiz__title'], ['.lwb-celtic-quiz__text'], ['.lwb-celtic-quiz__intro'], ['.lwb-celtic-quiz__question-head'], ['.lwb-celtic-quiz__option']] },
    { root: '.lwb-cbar-mode', items: [['.lwb-cbar-head__title'], ['.lwb-cbar-head__desc'], ['.lwb-cbar-head__count', 'fade'], ['.product-grid > .product-card']] },
    { root: '.lwb-celtic-metal', items: [['.lwb-celtic-eyebrow', 'fade'], ['.lwb-celtic-metal__title'], ['.lwb-celtic-metal__card']] },
    { root: '.lwb-celtic-meaning', items: [['.lwb-celtic-meaning__title'], ['.lwb-celtic-meaning__intro'], ['.lwb-celtic-meaning__tabs', 'fade'], ['.lwb-celtic-meaning__media', 'left']] },
    { root: '.lwb-celtic-custom', items: [['.lwb-celtic-custom__eyebrow', 'fade'], ['.lwb-celtic-custom__title'], ['.lwb-celtic-custom__step'], ['.lwb-celtic-custom__actions']] },
    { root: '.lwb-celtic-reviews', items: [['.lwb-celtic-reviews__title'], ['.lwb-celtic-reviews__subtext', 'fade'], ['.lwb-celtic-review']] },
    { root: '.lwb-celtic-guide', items: [['.lwb-celtic-guide__main'], ['.lwb-celtic-guide__side']] },
    { root: '.lwb-faq--split', items: [['.lwb-faq-eyebrow', 'fade'], ['.lwb-faq-heading'], ['.lwb-faq-item']] },
    { root: '.lwb-celtic-about', items: [['.lwb-celtic-about__title'], ['.lwb-celtic-about__text', 'fade']] }
  ];

  document.documentElement.classList.add('lwb-reveal-on');

  var observer = new IntersectionObserver(function (entries) {
    var visible = entries.filter(function (entry) { return entry.isIntersecting; }).map(function (entry) { return entry.target; });
    visible.sort(function (a, b) {
      return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
    });
    visible.forEach(function (el, index) {
      el.style.setProperty('--lwb-reveal-delay', Math.min(index, MAX_STAGGER_STEPS) * STAGGER_MS + 'ms');
      el.classList.add('is-revealed');
      observer.unobserve(el);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function scan(scope) {
    GROUPS.forEach(function (group) {
      var roots = [];
      if (scope.matches && scope.matches(group.root)) roots.push(scope);
      Array.prototype.push.apply(roots, scope.querySelectorAll(group.root));
      roots.forEach(function (root) {
        group.items.forEach(function (item) {
          root.querySelectorAll(item[0]).forEach(function (el) {
            if (el.hasAttribute('data-lwb-reveal')) return;
            el.setAttribute('data-lwb-reveal', item[1] || '');
            observer.observe(el);
          });
        });
      });
    });
  }

  function scanAll() { scan(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAll);
  } else {
    scanAll();
  }

  // Product grid: AJAX filtering swaps the section's HTML; load-more appends cards.
  document.addEventListener('lwb:collection-updated', scanAll);
  document.addEventListener('lwb:new-cards', scanAll);

  // Theme editor: a re-rendered section gets fresh markup.
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
